'use client'

import { ChakraProvider } from '@chakra-ui/react'
import type { SystemContext } from '@chakra-ui/react'
import type { ReactNode } from 'react'

import { system } from '@mangovoice/design-system'

import { ColorModeProvider, type ColorModeProviderProps } from './color-mode'

export interface ProviderProps extends Omit<
  ColorModeProviderProps,
  'children'
> {
  system?: SystemContext
  children?: ReactNode
}

export function Provider({
  system: systemProp = system,
  children,
  ...props
}: ProviderProps) {
  return (
    <ChakraProvider value={systemProp}>
      <ColorModeProvider enableSystem={true} defaultTheme="light" {...props}>
        {children}
      </ColorModeProvider>
    </ChakraProvider>
  )
}
